import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { FileUploadConfig } from '../type/file-upload-config';
import { isFunction } from '@pct-ts/typeguard';
import { resolveBoolean } from '@pct-ts/common';

@Pipe({
  name: 'isRemovable',
})
export class IsRemovablePipe implements PipeTransform {
  transform(config: FileUploadConfig, file: File): boolean {
    if (isFunction(config?.removableRow)) {
      return resolveBoolean(config.removableRow, file);
    }
    return config?.removableRow ?? false;
  }
}
